module.exports = __webpack_public_path__ + "static/media/ApaPerluAndaLakukanApabilaMembeliPolisiInsuransolehBankNegaraMalaysia.f4cccaa9.jpg";